import SavedECheckEUDD from './SavedECheckEUDD'

export default SavedECheckEUDD
